import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { skip, take, takeUntil, tap } from 'rxjs/operators';
import * as R from 'ramda';
import {
  AppSummarySectionConfig,
  CmsCountryObj,
  Labels,
  LanguageConfig,
} from '../app.models';
import { UtilsService } from '../services/utils.service';
import { MapService } from '../services/map.service';
import {
  AdddestinationCountryData,
  FeeLookup,
  SendCommit,
  SendValidate,
  TransactionActions,
} from '../store/transaction/transaction.actions';
import {
  EffectError,
  Error,
  FeeLookUpRequest,
  FeeLookupResponse,
  SenderRegistrationInfo,
  SendValidateRequest,
  SendValidateResponse,
} from '../store/transaction/types';
import {
  getSelectedLocationTrns,
  selectsendCommitResponse,
  selectSendValidateResponse,
  selectTransactionState,
} from '../store/transaction/transaction.selectors';
import { selectQueryParams } from '../store/query-params/query-param.selectors';
import { GFFP_FIELDS_CATEGORY, GffpData } from '../gffp/gffp.models';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { MgLocation } from '../models/location.model';
import { BaseComponent } from '../shared/base.component';
import { EstimateValue } from '../estimate/estimate.component';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';
import { QueryParams, SetQueryParams } from '../store/query-params';
import { Step } from './home.type';
import { GetEnums } from '../store/enumeration/enumeration.actions';
import { selectEnumFields } from '../store/enumeration/enumeration.selectors';
import {
  getSupportedLocale,
  getAssociatedLocale,
  PageTitles,
  displayFlashPage,
  isSdfCardFlow,
} from '../config/app-config';
import {
  ClearFeeQuoteAction,
  GetFeeQuoteAction,
} from '../store/fee-quote/fee-quote.actions';
import {
  selectFeeQuoteError,
  selectFeeQuoteState,
  isWalletFeeEnabled,
} from '../store/fee-quote/fee-quote.selectors';
import {
  hasError,
  serviceOptionsState,
  getIndicativeRateCountry,
  serviceOptions,
  isServerDown,
  cmsCountryDetails,
} from '../store/service-options';
import { getCurrentLabelsJson } from '../store/labels';
import {
  countriesInfo,
  CountryDetails,
  getCountryDetails,
} from '../store/countries';
import { isStatesResolved, stateInfo } from '../store/states';
import { isEmpty, omit, pathOr, pick } from 'ramda';
import { EnvService } from '../services/env.service';
import { BasicInfo } from '../store/types';
import { MobileBreakPointsService } from '../services/mobileBreakPoints.service';
import { GffpComponent } from '../gffp/gffp.component';
import { LocationSelectService } from '../services/location-select.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent extends BaseComponent implements OnInit, OnDestroy {
  @HostBinding('class') public klass = 'mat-elevation-z10';

  @ViewChild('stepper', { static: false }) public stepper!: MatStepper;
  @ViewChild(GffpComponent, { static: false })
  public gffpComponent: GffpComponent;
  private steps: { [id: string]: number } = {};
  amount = '';
  operation = '';
  token = '';
  currency!: string;
  showBack = false;
  country!: string;
  state = '';
  totalPayoutAmount!: number;
  exchangeAmount!: number;
  totalAmountToPay!: number;
  totalUSDCAmount!: number;
  totalAmount!: number;
  payOutAtLocation!: number;
  isWalletFeeEnabled$: Observable<any> | undefined;
  fees!: number;
  // partnerFees!: number; // TODO: add [partnerFees] = "partnerFees" on estimate-confirmation for partnerFees is applied
  taxes: number = 0;
  // partnerTaxes!: number;// TODO: add [partnerTaxes] = "partnerTaxes" on estimate-confirmation for partnerFees is applied
  exchangeRate: number = 1;
  payOutCurrency!: string;
  feesCurrencyCode!: string;
  // partnerFeesCurrencyCode!: string; //TODO: add [partnerFeesCurrencyCode]="partnerFeesCurrencyCode" on estimate-confirmation for partnerFees is applied
  taxesCurrencyCode!: string;
  // partnerTaxesCurrencyCode!: string; //TODO: add [partnerTaxesCurrencyCode] = "partnerTaxesCurrencyCode" on estimate-confirmation for partnerFees is applied
  payOutAtLocationCurrency!: string;
  transactionId!: string;
  sendCurrency!: string;
  selectedLocation!: MgLocation;
  sendValidatepPayload: SendValidateRequest = {};
  senderInfo!: SenderRegistrationInfo;
  error: string = '';
  email: string | undefined = '';
  locale: string = '';
  showBackIcon: boolean = true;
  google: any;
  enumerationsResponse$: Observable<any> | undefined;
  labels!: Labels;
  public labels$: Observable<any> | undefined;
  public options$: Observable<any> | undefined;
  public countries$: Observable<CountryDetails[]> | undefined;
  public isStatesResolved$: Observable<boolean> | undefined;
  public hasError$: Observable<boolean> | undefined;
  public isServerDown$: Observable<boolean> | undefined;
  public indicativeRateCountry$: Observable<boolean> | undefined;
  indicativeRateCountry!: boolean;
  options: any = {};
  walletProvider: any;
  appEstimateConfirmObj: any = {};
  countryDetails!: CmsCountryObj;
  disableAmount: boolean = false;
  isMobile$: Observable<boolean>;
  isMobile: boolean = true;
  isformFreeLocation: boolean = false;
  showFlashPage: boolean = false;
  mapiErrorCategoryCodes: any[] = [];
  languageList: LanguageConfig[] = [];
  isServiceOptionsError: boolean = false;
  queryParamsPayload: QueryParams;
  isSdfCardFlow: boolean;
  element: HTMLImageElement;
  bottomSheet: any;
  isExistingUser: boolean = false;
  endpointVersion: string;
  basicInfo: BasicInfo;
  stateOptions: any[];
  mobilevhOffset$: Observable<any>;

  // private isSignInEnabled: boolean = false; // Todo: Tim: Default to false for #feb11

  discounts = '0'; // todo: get it from  api object

  // TODO -- type _summaryData$ to AppSummaryConfig and map in home component
  private _summaryData$: BehaviorSubject<any> = new BehaviorSubject<any>(
    undefined
  );
  public readonly summaryData$: Observable<any> =
    this._summaryData$.asObservable();

  private _isAddrStateFieldError$: BehaviorSubject<any> =
    new BehaviorSubject<any>(undefined);
  public readonly isAddrStateFieldError$: Observable<any> =
    this._isAddrStateFieldError$.asObservable();

  private _isAddrCountryFieldError$: BehaviorSubject<any> =
    new BehaviorSubject<any>(undefined);
  public readonly isAddrCountryFieldError$: Observable<any> =
    this._isAddrCountryFieldError$.asObservable();

  private _sendValidateResponse$ = this.store.pipe(
    select(selectSendValidateResponse)
  );
  private _sendValResponseError$: BehaviorSubject<Error[] | null> =
    new BehaviorSubject<Error[] | null>(null);
  public sendValResponseError$ = this._sendValResponseError$.asObservable();

  private _readyToCommit$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public readonly readyToCommit$: Observable<boolean> =
    this._readyToCommit$.asObservable();
  public get readyToCommit() {
    return this._readyToCommit$.getValue();
  }

  private _gffpFieldNames: BehaviorSubject<string[]> = new BehaviorSubject<
    string[]
  >(undefined!);
  public readonly gffpFieldNames$: Observable<string[]> =
    this._gffpFieldNames.asObservable();

  public dataLayer = ((<any>window).dataLayer = (<any>window).dataLayer || []);

  // TESTING GFFP COMPONENT
  public gffpFieldNames = [
    'sender.firstName',
    'sender.middleName',
    'sender.lastName',
    'sender.secondLastName',
    'sender.dateOfBirth',
    // "sender.personalDetails.birthCountryCode",
    // "sender.personalDetails.citizenshipCountryCode",
    // "sender.personalDetails.occupationCode",
    'sender.primaryIdentification.issueCountryCode',
    'sender.primaryIdentification.issueCountrySubdivisionCode',
    'sender.primaryIdentification.typeCode',
    'sender.primaryIdentification.id',
    'sender.secondaryIdentification.issueCountryCode',
    'sender.secondaryIdentification.issueCountrySubdivisionCode',
    'sender.secondaryIdentification.typeCode',
    'sender.secondaryIdentification.id',
  ];

  public get summarySectionConfig() {
    return {
      title: {
        name: 'Cost Summary',
      },
      items: [
        {
          name: 'Cash Out Amount',
          value: this.amount,
          sendCurrency: this.currency,
        },
        {
          name: 'Fees',
          value: this.fees,
          sendCurrency: this.sendCurrency,
        },
      ],
    } as AppSummarySectionConfig;
  }

  private _watches: Subscription[] = [];
  commitResponse: any = null;
  serviceOptionsCmsMappingCountries: CmsCountryObj;
  receiveCurrency: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<any>,
    private actions$: Actions,
    private utilsService: UtilsService,
    private mapService: MapService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar,
    private _envService: EnvService,
    private _bottomSheet: MatBottomSheet,
    @Inject(DOCUMENT) private _document: Document,
    private mobileBreakPointService: MobileBreakPointsService
  ) {
    super();
    this.isSdfCardFlow = isSdfCardFlow;
    this.showFlashPage = displayFlashPage;
    this.mapService.loadMap(() => {
      this.google = google;
    });
  }

  // openBottomSheet(): void {
  //   if(this.isMobile) {
  //     this.element.src = 'assets/images/customer-support-mobile.svg';
  //     this.bottomSheet = this._bottomSheet.open(CardCustomerSupportComponent, {
  //       data: {
  //         labels: this.labels,
  //       }
  //     });

  //     this.bottomSheet.afterDismissed().subscribe(() => {
  //       this.element.src = 'assets/images/customer-support-mobile-white.svg';
  //     });
  //   }
  // }

  // menuOpened() {
  //   if(this.element) {
  //     this.element.src = 'assets/images/customer-support-mobile.svg';
  //   }
  // }

  // menuClosed() {
  //   if(this.element) {
  //     this.element.src = 'assets/images/customer-support-mobile-white.svg';
  //   }
  // }

  ngOnInit() {
    if (isSdfCardFlow) {
      this.store.dispatch(ClearFeeQuoteAction());
    }
    this.isMobile$ = this.mobileBreakPointService.mobileBreakPoints$;
    this.isMobile$.subscribe((mobile) => {
      // to supress bottomSheet upon change to desktop mode
      if (this.bottomSheet && !mobile) {
        this.bottomSheet.dismiss();
      }
      this.isMobile = mobile;
    });

    this.store.select(selectQueryParams).subscribe((queryParamsData: QueryParams) => { 
      if (queryParamsData.amount !== undefined &&
        ![undefined, ""].includes(queryParamsData.transactionId)
      ) {
        this.amount = String(queryParamsData.amount);
        this.disableAmount = true;
      }
    
      this.token = queryParamsData.token;
      this.operation = queryParamsData.operation || '';
      this.walletProvider = queryParamsData.walletProvider;
      this.locale = queryParamsData.locale;
    });

    this.options$ = this.store.select(serviceOptionsState);
    this.options$.subscribe((serviceOptions) => {
      // this.isSignInEnabled = serviceOptions?.isSignInEnabled ?? false; // Todo: Tim: need an alternate flag to check this, this would cause a loop back to sign in if enabled
      // if (this.isSignInEnabled === true) {
      //   this.router.navigate(['/signin'], { queryParamsHandling: 'preserve' });
      // }
      this.mapiErrorCategoryCodes =
        serviceOptions?.uiConfigs[0]?.mapiCategoryErrorCodes || [];
      this.languageList = serviceOptions?.uiConfigs[0]?.languageList;
      const receiveCurrencies =
        serviceOptions?.serviceOptions[0]?.sendCurrencyCodes ||
        serviceOptions?.serviceOptions[0]?.payoutCurrencyCodes;
      const localCurrency =
        serviceOptions?.serviceOptions[0]?.localCurrencyCode;
      this.receiveCurrency = receiveCurrencies
        ? receiveCurrencies.some((currency: any) => currency === localCurrency)
          ? localCurrency
          : receiveCurrencies[0]
        : 'USD';
    });
    this.store.select(cmsCountryDetails).subscribe((countries) => {
      this.serviceOptionsCmsMappingCountries = countries;
    });
    this.hasError$ = this.store.select(hasError);
    this.isServerDown$ = this.store.select(isServerDown);
    this.hasError$.subscribe((error) => {
      if (error) {
        // Most of the times service options won't provide error response when it fails
        // Created custome custom error
        const errorDetails = {
          category: 'SAS',
          code: '900',
          message: 'Error against service options SAS endpoint',
        };
        this._errorEvent(
          errorDetails,
          '',
          'serviceOptionsError',
          'estimateDetails'
        );
      }
    });
    this.indicativeRateCountry$ = this.store.select(getIndicativeRateCountry);
    this.indicativeRateCountry$.subscribe((indicativeRateCountry) => {
      this.indicativeRateCountry = indicativeRateCountry;
    });
    this.isStatesResolved$ = this.store.select(isStatesResolved);
    this.countries$ = this.store.select(countriesInfo);
    this.store.select(stateInfo).subscribe((states) => {
      this.stateOptions = states && states?.states ? states.states : [];
    });

    this.labels$ = this.store.select(getCurrentLabelsJson);
    this.labels$.subscribe((labels) => {
      this.labels = labels.labels;
      if (!labels?.labels?.stellar?.ok) {
        const errorDetails = {
          category: 'CMS',
          code: '403',
          message: 'Error against CMS endpoint',
        };
        this._errorEvent(errorDetails, '', 'cmsError', 'estimateDetails');
      }
    });

    this.store.select(getCountryDetails).subscribe((country) => {
      this.country = country?.code;
      this.countryDetails = country;
    });

    this.store.select(isStatesResolved).subscribe((isStatesLoaded) => {
      const objUrl = {};
      objUrl['event'] = 'userNavigatedToAnchorUI';
      objUrl['operation'] = this.operation;
      objUrl['transactionId'] = this.transactionId;
      if (isStatesLoaded && this.labels) {
        objUrl['sucessfullyNavigated'] = true;
      } else {
        objUrl['sucessfullyNavigated'] = false;
      }
      this.dataLayer.push(objUrl);
    });

    this.store.select(serviceOptionsState).subscribe((data) => {
      if (!!data.transactionId) {
        this.transactionId = data.transactionId;
        this._paramsDataEvent(this.queryParamsPayload);
      }
    });

    this.enumerationsResponse$ = this.store.pipe(select(selectEnumFields));
    this._watches.push(
      // SendValidate Success Response Handle
      this._sendValidateResponse$.subscribe(
        (response: SendValidateResponse) => {
          this._sendValResponseError$.next(response.errors!);
          this._readyToCommit$.next(response.readyForCommit || false);
          const adapterError =
            response.errors &&
            response.errors.find((error) => error.category?.includes('SAS-'));
          const validationError =
            response?.errors &&
            response?.errors?.find((error) =>
              this.mapiErrorCategoryCodes.includes(error.category)
            );
          if (
            adapterError &&
            (adapterError?.category === 'SAS-400' ||
              adapterError?.category === 'SAS-500')
          ) {
            const uiMessage = this.labels.stellar.error.unableToProcess;
            this._errorEvent(
              adapterError,
              uiMessage,
              'sendValidationError',
              'personalDetails'
            );
            this.openSnackBar(uiMessage, this.labels.stellar.dismiss, {
              duration: 10000,
              panelClass: ['bg'],
            });
            return;
          } else if (validationError) {
            this._isAddrStateFieldError$.next(validationError.code === '303');
            this._isAddrCountryFieldError$.next(validationError.code === '323');
            if (validationError?.code == '3556') {
              this.error = this.labels?.stellar?.error?.walletNotEligible;
            } else {
              this.error = validationError.message!;
            }
            this._errorEvent(
              validationError,
              this.error,
              'sendValidationError',
              'personalDetails'
            );
            this.openSnackBar(this.error, this.labels.stellar.dismiss, {
              duration: 10000,
              panelClass: ['bg'],
            });
            return;
          }

          const gffpErrors =
            (response.errors &&
              response.errors
                .find((error) => error.category === GFFP_FIELDS_CATEGORY)
                ?.offendingFields?.map(
                  (fieldObj: { field: any }) => fieldObj.field
                )) ||
            undefined!;
          console.log('SendValidateSuccessSub gffpErrors', gffpErrors); // Todo: remove: #may6
          this._gffpFieldNames.next(gffpErrors);

          // Needs GFFP Fields
          if (!response.readyForCommit && gffpErrors) {
            this._summaryData$.next(undefined);
            // const documentPayload = {
            //   userLanguage: 'en-US',
            //   targetAudience: 'CUSTOMER_FACING',
            //   payoutCurrencyCode: this.payOutCurrency,
            //   language: this.locale?.substring(0,2)
            // }
            // this.store.dispatch(GetDocumentId({getDocumentIdRequest: documentPayload}))
            this.stepper.selectedIndex = this.steps['gffp'];
            this._analyticsPageNavigation(
              'loadedIdPage',
              PageTitles.IDENTITY_PAGE
            );
          }

          // Can skip GFFP to Summary
          if (
            response.readyForCommit &&
            (!response.errors || response.errors.length === 0)
          ) {
            this.store
              .pipe(select(selectTransactionState), take(1))
              .subscribe((transactionData) => {
                console.log('select(selectTransactionState) - transactionData', transactionData); // Todo: remove: #may6
                this._summaryData$.next(transactionData);
                if (this.operation === 'deposit') {
                  this.stepper.selectedIndex = this.steps['fraud'];
                  this._analyticsPageNavigation(
                    'loadedFraudPage',
                    PageTitles.FRAUD_PAGE
                  );
                } else {
                  this.stepper.selectedIndex = this.steps['summary'];
                  this._analyticsPageNavigation(
                    'loadedSummaryPage',
                    PageTitles.SUMMARY_PAGE
                  );
                }
              });
          } else if (
            response.readyForCommit === false &&
            (!response.errors || response.errors.length === 0)
          ) {
            this.error = this.labels.stellar.error.somethingHasGoneWrong;
            this._errorEvent(
              undefined,
              this.error,
              'sendValidationError',
              'personalDetails'
            );
            this.openSnackBar(this.error, this.labels.stellar.dismiss, {
              duration: 10000,
              panelClass: ['bg'],
            });
          } else if (
            response.readyForCommit === false &&
            response.errors &&
            response.errors[0] &&
            response.errors[0]?.message &&
            response.errors[0]?.message === 'CORE REMOTE ERROR'
          ) {
            const uiMessage =
              this.labels?.stellar?.error?.somethingHasGoneWrong;
            this._errorEvent(
              response?.errors[0],
              uiMessage,
              'sendValidationError',
              'personalDetails'
            );
            this.openSnackBar(uiMessage, this.labels?.stellar?.dismiss, {
              duration: 10000,
              panelClass: ['bg'],
            });
          }
        }
      )
    );

    this.initSteps([
      'estimate',
      'location',
      'estimateConfirmation',
      'moreInfo',
      'basicInfo',
      'address',
      'gffp',
      'fraud',
      'summary',
      'confirmation',
    ]);

    this.route.queryParams.subscribe((params) => {
      // Todo: cleanup these item. Most of these are no longer provided in query params
      this.amount = params['amount'];
      this.disableAmount = !!this.amount;
      this.operation = params['operation'];
      this.token = params['token'];
      this.walletProvider = params['wallet_provider'];
      this.email = params['email_address'];
      this.locale =
        params['lang'] && params['lang'].length === 2
          ? getAssociatedLocale(params['lang'])
          : getSupportedLocale(params['lang']);
      this.endpointVersion = this.isClientNameInJWT(this.token) ? 'v3' : 'v2';

      const payload: QueryParams = {
        amount: Number(this.amount),
        operation: this.operation,
        token: this.token,
        email: this.email,
        assetCode: params['asset_code'],
        isCashoutAllowed: params['cashout_allowed'],
        cashoutCountry: params['cashout_country'],
        cashoutCurrencies: params['cashout_currencies'],
        walletProvider: this.walletProvider,
        locale: this.locale,
        endpoint: this.endpointVersion || 'v2',
      };
      this.queryParamsPayload = payload;
      this.store.dispatch(
        SetQueryParams({
          queryParams: { queryParams: payload },
          endpoint: this.endpointVersion,
        })
      );

      // this.store.dispatch(GetServiceOptions({getOptionsRequest: {token: this.token, language: this.locale?.substring(0,2), operation: this.operation}}))
    });

    // this.store.pipe(select(getLocationState)).subscribe((location) => {
    //   // ToDo: Need to check why it is not working
    //   console.log("selectLocationState LOC: ", location);
    // });

    this.store.pipe(select(getSelectedLocationTrns)).subscribe((location) => {
      this.selectedLocation = location;
      this.isformFreeLocation = this.selectedLocation?.locationServices
        ?.formFreeCompletion
        ? this.selectedLocation?.locationServices?.formFreeCompletion
        : false;
      if (
        this.isSdfCardFlow &&
        !isEmpty(this.selectedLocation) &&
        this.operation === 'deposit' &&
        this.amount
      ) {
        this.callApi();
      }
    });

    this.isWalletFeeEnabled$ = this.store.pipe(select(isWalletFeeEnabled));
    
    if (isSdfCardFlow) {
      this.store
        .pipe(select(selectFeeQuoteState))
        .pipe(skip(1))
        .subscribe((data) => {
          console.log('selectFeeQuoteState DATA : ', data);
          this.senderInfo = data?.senderProfile!;
          this.isExistingUser =
            !R.isEmpty(this.senderInfo) &&
            this.senderInfo?.firstName &&
            this.senderInfo?.lastName &&
            !R.isEmpty(this.senderInfo.address) &&
            this.senderInfo.address?.line1
              ? true
              : false;
          this.totalAmount = pathOr(
            0,
            ['transactions', 0, 'sendAmountDetails', 'amount', 'value'],
            data
          );
          this.payOutCurrency =
            this.operation === 'withdraw'
              ? pathOr(
                  'USD',
                  [
                    'transactions',
                    0,
                    'payoutAmountDetails',
                    'amount',
                    'currencyCode',
                  ],
                  data
                )
              : pathOr(
                  'USD',
                  [
                    'transactions',
                    0,
                    'sendAmountDetails',
                    'amount',
                    'currencyCode',
                  ],
                  data
                );
          this.exchangeRate =
            this.operation === 'withdraw'
              ? pathOr(
                  '?',
                  ['transactions', 0, 'payoutAmountDetails', 'fxRate'],
                  data
                )
              : pathOr(
                  '?',
                  ['transactions', 0, 'sendAmountDetails', 'fxRate'],
                  data
                );
        });
    } else {
      this.loadOldFeeLookUpDate();
    }
    this.store.select(selectsendCommitResponse).subscribe((commitResponse) => {
      this.commitResponse = commitResponse;
      const error =
        this.commitResponse?.errors && this.commitResponse?.errors[0];
      if (error) {
        this._errorEvent(error, '', 'sendCommitError', 'sendCommitDetails');
      }
      if (this.commitResponse) {
        this.cdr.detectChanges();
      }
    });

    this.store
      .pipe(select(selectFeeQuoteError))
      .pipe(skip(1))
      .subscribe((error) => {
        // console.log('FEE QUOTE ERROR : ', error);
        let errorMessage = '';
        if (error && error?.category === 'SAS-400' && error?.code === '401') {
          errorMessage = this.labels.stellar.error.amountExceededBalance;
        } else if (
          error &&
          (error?.category === 'SAS-400' || error?.category === 'SAS-500')
        ) {
          errorMessage = this.labels.stellar.error.unableToProcess;
        } else if (
          error &&
          error?.category === 'MAPI-20000' &&
          error?.code === '4016'
        ) {
          errorMessage = this.labels.stellar.error.maximumReceiveAmount;
        } else if (
          error &&
          error?.category === 'MAPI-20000' &&
          error?.code === '4015'
        ) {
          errorMessage = this.labels.stellar.error.receiveAmountLessThanMin;
        } else if (
          error &&
          error?.category === 'MAPI-20000' &&
          error?.code === '645'
        ) {
          errorMessage = this.labels.stellar.error.receiveAmountLessThanMin;
        } else if (
          error &&
          error?.category === 'MAPI-20000' &&
          error?.code === '301'
          // error?.code === '301' && // TODO: MAWX-1730 - testing for Aug 27th could not be completed due to PROD INc work. Commenting these changes out 
          // this.operation === "withdraw"
        ) {
          errorMessage = this.labels.stellar.error.maximumWithdrawalAmount;
        // } else if ( // TODO: MAWX-1730 - testing for Aug 27th could not be completed due to PROD INc work. Commenting these changes out 
        //   error &&
        //   error?.category === 'MAPI-20000' &&
        //   error?.code === '427' &&
        //   this.operation === "withdraw"
        // ) {
        //   errorMessage = error.message//this.labels.stellar.error.maximumWithdrawalAmount;
        } else if (error) {
          errorMessage = error.message;
        } else {
          errorMessage = this.labels.stellar.error.processingError;
        }

        if (!errorMessage) {
          errorMessage = this.labels.stellar.error.processingError;
        }
        this._errorEvent(
          error,
          errorMessage,
          'feeQuoteError',
          'estimateDetails'
        );
        this.openSnackBar(errorMessage, this.labels.stellar.dismiss, {
          duration: 10000,
          panelClass: ['bg'],
        });
      });
  }

  loadOldFeeLookUpDate() {
    this.actions$
      .pipe(
        ofType(TransactionActions.feeLookupFailed),
        tap(() => console.log('feeQuote Failed')),
        takeUntil(this.destroy$)
      )
      .subscribe((action) => {
        let errorMessage = '';
        const data: EffectError = action;
        const error = data?.error && data?.error?.errors[0];
        if (error && error?.category === 'SAS-400' && error?.code === '401') {
          errorMessage = this.labels.stellar.error.amountExceededBalance;
        } else if (
          error &&
          (error?.category === 'SAS-400' || error?.category === 'SAS-500')
        ) {
          errorMessage = this.labels.stellar.error.unableToProcess;
        } else if (
          error &&
          error?.category === 'MAPI-20000' &&
          error?.code === '4016'
        ) {
          errorMessage = this.labels.stellar.error.maximumReceiveAmount;
        } else if (
          error &&
          error?.category === 'MAPI-20000' &&
          error?.code === '4015'
        ) {
          errorMessage = this.labels.stellar.error.receiveAmountLessThanMin;
        } else if (
          error &&
          error?.category === 'MAPI-20000' &&
          error?.code === '645'
        ) {
          errorMessage = this.labels.stellar.error.receiveAmountLessThanMin;
        } else if (
          error &&
          error?.category === 'MAPI-20000' &&
          error?.code === '301'
        ) {
          errorMessage = this.labels.stellar.error.maximumWithdrawalAmount;
        } else if (error) {
          errorMessage = error.message;
        } else {
          errorMessage = this.labels.stellar.error.processingError;
        }

        if (!errorMessage) {
          errorMessage = this.labels.stellar.error.processingError;
        }
        this._errorEvent(
          error,
          errorMessage,
          'feeQuoteError',
          'estimateDetails'
        );
        this.openSnackBar(errorMessage, this.labels.stellar.dismiss, {
          duration: 10000,
          panelClass: ['bg'],
        });
      });

    this.actions$
      .pipe(
        ofType(TransactionActions.feeLookupSuccess),
        // tap(() => console.log("feeQuote Success")),
        takeUntil(this.destroy$)
      )
      .subscribe((action) => {
        const data: FeeLookupResponse = action['feeLookupResponse'];
        this.senderInfo = data?.senderProfile!;
        this.email = this.senderInfo?.email;
        this.isExistingUser =
          !R.isEmpty(this.senderInfo) &&
          this.senderInfo?.firstName &&
          this.senderInfo?.lastName &&
          !R.isEmpty(this.senderInfo.address) &&
          this.senderInfo.address?.line1
            ? true
            : false;
        console.log('this.isExistingUser : ', this.isExistingUser);
        const transaction = data?.transactions && data?.transactions[0];
        if (transaction) {
          this.totalPayoutAmount =
            this.operation === 'withdraw'
              ? transaction?.payoutAmountDetails?.amount?.value!
              : transaction?.sendAmountDetails?.amount?.value!;
          this.exchangeAmount = transaction?.sendAmountDetails?.amount?.value!;
          this.exchangeRate = transaction?.payoutAmountDetails?.fxRate!;
          this.payOutCurrency =
            this.operation === 'withdraw'
              ? transaction?.payoutAmountDetails?.amount?.currencyCode!
              : transaction?.sendAmountDetails?.amount?.currencyCode!;
          this.totalUSDCAmount =
            this.operation === 'withdraw'
              ? transaction?.sendAmountDetails?.totalAmount?.value!
              : transaction?.payoutAmountDetails?.totalAmount?.value!;
          this.totalAmountToPay =
            this.operation === 'withdraw'
              ? transaction?.payoutAmountDetails?.totalAmount?.value!
              : transaction?.sendAmountDetails?.totalAmount?.value!;
          this.totalAmount = transaction?.sendAmountDetails?.amount?.value!;
          this.fees = transaction?.sendAmountDetails?.fees?.value!;
          this.feesCurrencyCode =
            transaction?.sendAmountDetails?.fees?.currencyCode!;
          this.taxes = transaction?.sendAmountDetails?.taxes?.value!;
          this.taxesCurrencyCode =
            transaction?.sendAmountDetails?.taxes?.currencyCode!;
          this.transactionId = transaction?.transactionId!;
          this.payOutAtLocation =
            transaction?.sendAmountDetails?.totalAmount?.value!;
          this.payOutAtLocationCurrency =
            transaction?.sendAmountDetails?.totalAmount?.currencyCode!;
          this.sendCurrency =
            transaction?.sendAmountDetails?.amount?.currencyCode!;
          if (this.totalPayoutAmount) {
            this.error = '';
            this.stepper.selectedIndex = this.isSdfCardFlow
              ? this.steps['registration']
              : this.steps['estimateConfirmation'];
            this._analyticsPageNavigation(
              'loadedEstimateConfirmationPage',
              PageTitles.ESTIMATE_CONFIRM_PAGE
            );
          }
        } else {
          const uiMessage = this.labels.stellar.error.processingError;
          this.openSnackBar(uiMessage, this.labels.stellar.dismiss, {
            duration: 10000,
            panelClass: ['bg'],
          });
        }
      });
  }

  openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    this._snackBar.open(message, action, config);
  }

  public ngOnDestroy(): void {
    this._watches.forEach((watch) => watch.unsubscribe());
  }

  private initSteps(steps: string[]): void {
    steps.forEach((s, i) => {
      this.steps[s] = i;
    });
  }

  onEstimateSubmit(data: any) {
    this.amount = data.amount;
    if (this.operation !== 'deposit') {
      this.callEstimate(data);
    } else {
      this.onNext();
    }
  }

  onNext(nextStep?: number) {
    switch (nextStep || this.stepper.selectedIndex) {
      case Step.estimate:
        this.stepper.selectedIndex = this.steps['location'];
        this._analyticsPageNavigation(
          'loadedLocationPage',
          PageTitles.LOCATION_PAGE
        );
        break;
      case Step.moreInfo:
        if (!this.isExistingUser) {
          this.stepper.selectedIndex = this.steps['moreInfo'];
          this._analyticsPageNavigation(
            'loadedMoreInfoPage',
            PageTitles.MORE_INFO_PAGE
          );
        } else {
          this.stepper.selectedIndex = this.steps['basicInfo'];
          this._analyticsPageNavigation(
            'loadedBasicInfoPage',
            PageTitles.BASIC_INFO_PAGE
          );
        }
        break;
      case Step.location:
        this.stepper.selectedIndex = this.steps['estimateOnConfirmation'];
        this._analyticsPageNavigation(
          'loadedEstimateConfirmationPage',
          PageTitles.ESTIMATE_CONFIRM_PAGE
        );
        break;
      case Step.estimateConfirmation:
        this._analyticsBtnClickEvent(
          'estConfirmationEvent',
          PageTitles.ESTIMATE_CONFIRM_PAGE
        );
        const enumPayload = {
          userLanguage: 'en-US',
          targetAudience: 'CUSTOMER_FACING',
          countryCode: this.country,
          language: this.locale?.substring(0, 2),
        };
        this.store.dispatch(
          GetEnums({
            getEnumRequest: enumPayload,
            endpoint: this.endpointVersion,
          })
        );
        // this.stepper.selectedIndex = this.steps['registration']
        this.stepper.selectedIndex = this.steps['basicInfo'];
        this._analyticsPageNavigation(
          'loadedRegistrationPage',
          PageTitles.REGISTRATION_PAGE
        );
        break;
      case Step.fraud:
        this._analyticsBtnClickEvent(
          'fraudRulesAcceptEvent',
          PageTitles.FRAUD_PAGE
        );
        this.stepper.selectedIndex = this.steps['summary'];
        this._analyticsPageNavigation(
          'loadedSummaryPage',
          PageTitles.SUMMARY_PAGE
        );
        break;
      default:
        break;
    }
  }

  onBack() {
    switch (this.stepper.selectedIndex) {
      case Step.estimateConfirmation:
        if (!this.isSdfCardFlow && this.operation === 'deposit') {
          this.stepper.selectedIndex = this.steps['location'];
          this._analyticsPageNavigation(
            'BackToLocationPage',
            PageTitles.LOCATION_PAGE
          );
          this.cdr.detectChanges();
        } else {
          this.stepper.selectedIndex = this.steps['estimate'];
          this._analyticsPageNavigation(
            'BackToEstimatePage',
            PageTitles.ESTIMATE_PAGE
          );
        }
        break;
      case Step.basicInfo:
        if (this.isExistingUser) {
          this.stepper.selectedIndex = this.steps['estimate'];
          this._analyticsPageNavigation(
            'BackToEstimatePage',
            PageTitles.ESTIMATE_PAGE
          );
          this.cdr.detectChanges();
        } else {
          this.stepper.selectedIndex = this.steps['moreInfo'];
          this._analyticsPageNavigation(
            'BackToMoreInfoPage',
            PageTitles.MORE_INFO_PAGE
          );
        }
        break;
      case Step.summary:
        if (this.operation === 'deposit') {
          this.stepper.selectedIndex = this.steps['fraud'];
          this._analyticsPageNavigation(
            'BackToFraudPage',
            PageTitles.FRAUD_PAGE
          );
        } else {
          this.stepper.selectedIndex = this.steps['gffp'];
          this._analyticsPageNavigation(
            'BackToIdentityPage',
            PageTitles.IDENTITY_PAGE
          );
        }
        break;
      default:
        this.stepper.previous();
        break;
    }
  }

  getSendCurrency() {
    if (this.operation === 'withdraw') {
      return 'USDC';
    }
    return this.country === 'USA' ? 'USD' : this.payOutCurrency;
  }

  getpayoutCurrency() {
    if (this.operation === 'withdraw') {
      return this.payOutCurrency;
    }
    return 'USDC';
  }

  updateBasicInfoValuesToString(basic: BasicInfo): BasicInfo {
    if (basic !== null && typeof basic === 'object') {
      let newBasicObj: any = {};
      for (const key in basic) {
        if (basic.hasOwnProperty(key)) {
          if (typeof basic[key] === 'object' && basic[key] !== null) {
            newBasicObj[key] = this.updateBasicInfoValuesToString(basic[key]);
          } else {
            newBasicObj[key] = basic[key] !== null ? String(basic[key]) : '';
          }
        }
      }
      return newBasicObj;
    }
    return basic;
  }

  onBasicSubmitInfo(value: BasicInfo) {
    this.basicInfo = this.updateBasicInfoValuesToString(value);
    // console.log("basicInfo : ", this.basicInfo.phone);
    this.stepper.selectedIndex = this.steps['address'];
    this._analyticsBtnClickEvent(
      'onBasicInfoSubmitEvent',
      PageTitles.ADDRESS_PAGE
    );
    const enumPayload = {
      userLanguage: 'en-US',
      targetAudience: 'CUSTOMER_FACING',
      countryCode: this.country,
      language: this.locale?.substring(0, 2),
    };
    this.store.dispatch(
      GetEnums({ getEnumRequest: enumPayload, endpoint: this.endpointVersion })
    );
  }

  onRegSubmit(value: any) {
    this._isAddrCountryFieldError$.next(undefined);
    this._isAddrStateFieldError$.next(undefined);
    this._analyticsBtnClickEvent(
      'onAddressSubmitEvent',
      PageTitles.ADDRESS_PAGE
    );
    // console.log('value : ', value);
    this.error = '';
    const phoneNumber = pathOr(
      value?.phone?.phoneNumber,
      ['phone', 'phoneNumber'],
      this.basicInfo
    ).trim();
    this.sendValidatepPayload = {
      targetAudience: 'CONSUMER_FACING',
      userLanguage: 'en-US',
      destinationCountryCode: this.country,
      destinationCountrySubdivisionCode: this.state,
      payoutOptionCode: 'WILL_CALL',
      sendAmount: {
        value: this.totalAmount,
        currencyCode: this.getSendCurrency(),
      },
      payoutCurrencyCode: this.getpayoutCurrency(),
      sender: {
        firstName: pathOr(
          value?.firstName,
          ['firstName'],
          this.basicInfo
        ).trim(),
        lastName: pathOr(value?.lastName, ['lastName'], this.basicInfo).trim(),
        middleName: pathOr(
          value?.middleName,
          ['middleName'],
          this.basicInfo
        ).trim(),
        secondLastName: pathOr(
          value?.secondLastName,
          ['secondLastName'],
          this.basicInfo
        ).trim(),
        email: this.email,
        notificationLanguagePreference:
          this.senderInfo?.notificationLanguagePreference,
        address: {
          // Trimming the fields based on MAPI rules
          line1: value.address.substring(0, 30).trim(),
          line2: value.addressLine2
            ? value.addressLine2.substring(0, 30).trim()
            : '',
          city: value.city.substring(0, 20).trim(),
          countrySubdivisionCode: value.state,
          countryCode: value.country,
          postalCode: value.postalCode.substring(0, 10).trim(),
        },
        dateOfBirth: pathOr(
          value?.dateOfBirth,
          ['dateOfBirth'],
          this.basicInfo
        ).trim(),
        mobilePhone: {
          number: this.utilsService.formatToRawPhoneNumber(phoneNumber).trim(),
          countryDialCode: pathOr(
            value?.phone?.countryDialCode,
            ['phone', 'countryDialCode'],
            this.basicInfo
          ).trim(),
        },
      },
      additionalTransactionDetails: {
        getRelationshipToReceiver: true,
      },
      receiverSameAsSender: true,
    };
    if (this.operation === 'deposit') {
      this.sendValidatepPayload.stagingInfo = {
        stageTransaction: true,
        sendLocationAgentPartnerId:
          this.selectedLocation?.locationDetails?.locationId!,
        formFreeCompletion: this.isformFreeLocation,
      };
      (this.sendValidatepPayload.payoutOptionCode = 'DIRECT_TO_ACCT'),
        (this.sendValidatepPayload.destinationCountrySubdivisionCode =
          this.selectedLocation?.locationDetails?.country &&
          this.selectedLocation?.locationDetails?.state
            ? `${this.selectedLocation?.locationDetails?.country}-${this.selectedLocation?.locationDetails?.state}`
            : '');
    }

    if (!this.sendValidatepPayload?.sender?.email) {
      delete this.sendValidatepPayload?.sender?.email;
    }
    this.store.dispatch(
      SendValidate({
        transactionId: this.transactionId,
        payload: this.sendValidatepPayload,
        endpoint: this.endpointVersion,
      })
    );

    this.actions$
      .pipe(
        ofType(
          TransactionActions.sendValidateSuccess,
          TransactionActions.sendValidateFailed
        )
      )
      .subscribe((action) => {
        const data: SendValidateResponse = action['sendValidateResponse'];
        const internalError = action['error'];
        const errors = data && data.errors!;
        if (errors && errors[0]?.code === '3556') {
          this.openSnackBar(
            this.labels?.stellar?.error?.walletNotEligible,
            this.labels.stellar.dismiss,
            {
              duration: 10000,
              panelClass: ['bg'],
            }
          );
        } else if (errors && errors[0]?.offendingFields?.length === 0) {
          this.error = errors[0].message!;
          this.openSnackBar(this.error, this.labels.stellar.dismiss, {
            duration: 10000,
            panelClass: ['bg'],
          });
        } else if (!data || internalError) {
          this.openSnackBar(
            this.labels.stellar.error.processingError,
            this.labels.stellar.dismiss,
            {
              duration: 10000,
              panelClass: ['bg'],
            }
          );
        }
      });

    this.actions$
      .pipe(ofType(TransactionActions.sendValidateFailed))
      .subscribe((action) => {
        // TODO -- handle error thru store if needed. Success handle moved to store watcher.
        //  Action (SendValidate) -> Reducer (SendRequest Updated) -> Effects (Request from api)
        //    -> Action (Success/Failed) -> Reducer (Update Store with Success Response/Error Response)
        //
        //  when things become more complex we can rely on the store to be settled (due to order of operations for ngrx)
        //  if we watch a store value for success instead of the success action
        //  before moving onto additional steps
      });
  }

  public callEstimate(estData: EstimateValue): void {
    // console.log("DATA : ", estData);
    this.currency = estData.currency!;
    // console.log("this.selectedLocation :" , this.selectedLocation)
    if (estData.amount) {
      this.amount = this.estimateAmount(estData);
    }
    if (
      (this.operation === 'deposit' && !isEmpty(this.selectedLocation)) ||
      this.operation === 'withdraw'
    ) {
      this.invokeApi(estData);
    }
  }

  private invokeApi(estData: EstimateValue) {
    this.error = '';
    this.country = estData.country!;
    this.currency = estData.currency!;
    this.state = estData.state!;
    if (estData.amount) {
      this.amount = this.estimateAmount(estData);
    }
    this.store.dispatch(
      AdddestinationCountryData({
        destinationCountryData: {
          ...estData,
          amount: this.amount,
        },
      })
    );

    this._estimateDataEvent(estData);

    // ToDo - for deposit flow - we have invoke quote only after selected a location
    if (this.isSdfCardFlow) {
      this.callApi();
    } else {
      if (this.operation === 'withdraw') {
        this.callApi();
      } else {
        this.onNext();
      }
    }
  }

  private callApi() {
    this.error = '';
    const feePayLoad: FeeLookUpRequest = {
      targetAudience: 'CONSUMER_FACING',
      userLanguage: this.locale,
      destinationCountryCode: this.country,
      destinationCountrySubdivisionCode: this.state,
    };

    if (this.operation === 'deposit' && !isEmpty(this.selectedLocation)) {
      feePayLoad.stagingInfo = {
        stageTransaction: true,
        sendLocationAgentPartnerId:
          this.selectedLocation?.locationDetails?.locationId!,
        formFreeCompletion: this.isformFreeLocation,
      };
      feePayLoad.payoutAmount = {
        value: parseFloat(this.amount),
        currencyCode: 'USDC',
      };
      feePayLoad.customFields = [
        {
          key: 'selectedLocation',
          value: JSON.stringify(this.selectedLocation),
        },
      ];
      feePayLoad.sendCurrencyCode = this.receiveCurrency || this.currency;
      (feePayLoad.payoutOptionCode = 'DIRECT_TO_ACCT'),
        (feePayLoad.destinationCountrySubdivisionCode =
          this.selectedLocation?.locationDetails?.country &&
          this.selectedLocation?.locationDetails?.state
            ? `${this.selectedLocation?.locationDetails?.country}-${this.selectedLocation?.locationDetails?.state}`
            : '');
    } else if (this.operation === 'withdraw') {
      feePayLoad.customFields = [
        {
          key: 'selectedCountry',
          value: this.country,
        },
      ];
      feePayLoad.sendAmount = {
        value: parseFloat(this.amount),
        currencyCode: 'USDC',
      };
      feePayLoad.payoutCurrencyCode = this.currency
        ? this.currency
        : this.receiveCurrency;
      feePayLoad.payoutOptionCode = 'WILL_CALL';
    }

    if (isSdfCardFlow) {
      this.store.dispatch(
        GetFeeQuoteAction({
          feeLookupRequest: feePayLoad,
          endpoint: this.endpointVersion,
        })
      );
    } else {
      this.store.dispatch(
        FeeLookup({
          feeLookupRequest: feePayLoad,
          endpoint: this.endpointVersion,
        })
      );
    }
  }

  onCommit() {
    this._analyticsBtnClickEvent(
      'onSummarySubmitEvent',
      PageTitles.SUMMARY_PAGE
    );
    this.error = '';
    this.store.dispatch(
      SendCommit({
        transactionId: this.transactionId,
        isQrCodeRequired: !this.country && this.operation === 'deposit',
        locale: this.locale,
        endpoint: this.endpointVersion,
      })
    );
    this.showBackIcon = false;
    // console.log(" this.stepper 01 : ",  this.stepper);
    this.stepper.selectedIndex = this.steps['confirmation'];
    // console.log(" this.stepper 02 : ",  this.stepper);
    this._analyticsPageNavigation(
      'loadedConfirmationPage',
      PageTitles.CONFIRMATION_PAGE
    );
  }

  onGffpSubmit(data: GffpData) {
    console.log("GFFP DATA :", data) // Todo: Remove: #may6
    const familyNames = pick(['additionalFamilyNames'], data.sender);
    console.log("familyNames :", familyNames) // Todo: Remove: #may6
    const senderWithoutFamilyNames = omit(
      ['additionalFamilyNames'],
      data.sender
    );
    this.error = '';
    let payload = { ...this.sendValidatepPayload };
    let senderPayload = {};
    senderPayload = {
      ...this.sendValidatepPayload.sender,
      ...senderWithoutFamilyNames,
    };

    if (
      !isEmpty(familyNames) &&
      pathOr('', ['additionalFamilyNames', 'mothersMaidenName'], familyNames)
    ) {
      const familyArray = [
        {
          lastName: pathOr(
            '',
            ['additionalFamilyNames', 'mothersMaidenName'],
            familyNames
          ),
          type: 'MOTHER_S_MAIDEN_NAME',
        },
      ];
      senderPayload['additionalFamilyNames'] = familyArray;
    }

    payload.sender = { ...senderPayload };
    this.sendValidatepPayload = {
      ...this.sendValidatepPayload,
      sender: {
        ...this.sendValidatepPayload.sender,
        ...senderPayload,
      },
    };
    if (
      senderWithoutFamilyNames.additionalTransactionDetails ||
      data.additionalTransactionDetails
    ) {
      this.sendValidatepPayload = {
        ...this.sendValidatepPayload,
        additionalTransactionDetails: {
          getRelationshipToReceiver: true,
          ...data.additionalTransactionDetails,
        },
      };
    }
    this._analyticsBtnClickEvent('onGffpSubmitEvent', PageTitles.IDENTITY_PAGE);
    this._summaryData$.next(undefined); // resetting summary data
    this.store.dispatch(
      SendValidate({
        transactionId: this.transactionId,
        payload: this.sendValidatepPayload,
        endpoint: this.endpointVersion,
      })
    );
  }

  onLocationSelected(data: any) {
    this._analyticsBtnClickEvent(
      'onLocationSelectedEvent',
      PageTitles.LOCATION_PAGE,
      data
    );
    this.selectedLocation = data;
    this.isformFreeLocation = this.selectedLocation?.locationServices
      ?.formFreeCompletion
      ? this.selectedLocation?.locationServices?.formFreeCompletion
      : false;
    this.callApi();
    //this.callEstimate(data);
  }

  public scrollToTopOnStepChange(): void {
    this.stepper.animationDone
      .pipe(take(1))
      .subscribe(() =>
        this._document.body.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      );
    if (this.stepper) {
      this.stepper.selectionChange.subscribe((event) => {
        if (
          event.previouslySelectedIndex > event.selectedIndex &&
          this.gffpComponent
        ) {
          this.gffpComponent.closeAllAutoCompletePanels();
        }
      });
    }
  }

  public decodeJWT(token: string): string {
    const arrayToken = token.split('.');
    const decodedToken = JSON.parse(atob(arrayToken[1]));
    return decodedToken;
  }

  public isClientNameInJWT(token: string): boolean {
    const decodedToken = this.decodeJWT(token);
    return !!decodedToken['client_name'];
  }

  private estimateAmount(estData: any): any {
    return estData.amount
      ? typeof estData.amount === 'string'
        ? Number(estData.amount).toFixed(2)
        : estData.amount.toFixed(2)
      : 0;
  }

  private _paramsDataEvent(params: Params): void {
    const paramsObj = {};
    paramsObj['event'] = 'loadedEstimatePage';
    paramsObj['language'] = this.locale?.substring(0, 2);
    paramsObj['country'] = this.locale?.substring(3, 5);
    paramsObj['transaction-Id'] = this.transactionId;
    paramsObj['operation'] = this.operation;
    paramsObj['wallet-provider'] = this.walletProvider;
    paramsObj['page-title'] = PageTitles.ESTIMATE_PAGE;
    this.dataLayer.push(paramsObj);
  }

  private _estimateDataEvent(estData: EstimateValue) {
    // console.log('What is estimate Data', estData)
    const estObj = {};
    estObj['event'] = 'estimateDetails';
    estObj['country'] = estData?.country;
    estObj['currency'] = estData?.currency;
    estObj['state'] = estData?.state;
    estObj['operation'] = this.operation;
    estObj['transaction-id'] = this.transactionId;
    estObj['amount'] = this.estimateAmount(estData);
    estObj['page-title'] = PageTitles.ESTIMATE_PAGE;
    this.dataLayer.push(estObj);
  }

  private _errorEvent(
    error: Error | undefined,
    message: string,
    event: string,
    pageName: string
  ) {
    const errorObj = {};
    errorObj['event'] = event;
    errorObj['event-page-name'] = pageName;
    errorObj['transaction-id'] = this.transactionId;
    errorObj['operation'] = this.operation;
    if (error) {
      errorObj['error-category'] = error?.category;
      errorObj['error-code'] = error?.code;
      errorObj['backend-error-msg'] = error?.message;
    } else {
      errorObj['ready-for-commit'] = false;
    }

    errorObj['ui-custom-error-msg'] = message;
    this.dataLayer.push(errorObj);
  }

  private _analyticsBtnClickEvent(
    event: string,
    pageTitle: string,
    data?: any
  ) {
    const clickInfoObj = {};
    clickInfoObj['event'] = event;
    clickInfoObj['transaction-id'] = this.transactionId;
    clickInfoObj['page-title'] = pageTitle;
    clickInfoObj['operation'] = this.operation;
    // To capture selected cash in location details
    if (data) {
      clickInfoObj['retailer-id'] = data?.locationDetails?.retailerId;
      clickInfoObj['form-free-completion'] =
        data?.locationServices?.formFreeCompletion;
    }
    if (event === 'fraudRulesAcceptEvent') {
      clickInfoObj['is-fraud-rules-accepted'] = true;
    }
    this.dataLayer.push(clickInfoObj);
  }

  private _analyticsPageNavigation(event: string, pageTitle: string) {
    const clickInfoObj = {};
    clickInfoObj['event'] = event;
    clickInfoObj['transaction-id'] = this.transactionId;
    clickInfoObj['page-title'] = pageTitle;
    clickInfoObj['operation'] = this.operation;
    this.dataLayer.push(clickInfoObj);
  }
}
